<template>
  <nav class="page-sidebar"
       data-pages="sidebar"
       @mouseover="SET_SIDEBAR_VISIBLE(true)"
       @mouseleave="SET_SIDEBAR_VISIBLE(false)"
       :class="{ 'menu-slide': getSidebarVisible, 'visible': getSidebarOpen }">
    <div class="sidebar-overlay-slide from-top">
    </div>

    <div class="sidebar-header">
      <img src="../../assets/img/2424fit-logo.svg" alt="logo" class="brand" width="195">
    </div>
    <div class="sidebar-menu">
      <ul class="menu-items">
        <li class="m-t-30">
          <router-link class="detailed"
                       :to="{ name: 'home' }">
            <span class="title">{{ $t('menu_home') }}</span>
            <span class="details">{{ getSurveys.length }} {{ $t('menu_home_open') }}</span>
          </router-link>
          <span class="icon-thumbnail"><home-icon /></span>
        </li>
        <li class="">
          <router-link :to="{ name: 'calendar' }">
            <span class="title">{{ $t('menu_my_schedule') }}</span>
          </router-link>
          <span class="icon-thumbnail "><calendar-icon /></span>
        </li>
        <li :class="{ 'open active': menu.recipeOpen }">
          <a href="#"
             @click="openMenuItem('recipeOpen')">
            <span class="title">{{ $t('menu_recipes') }}</span>
            <span class="arrow"
                  :class="{ 'open active': menu.recipeOpen }"></span>
          </a>
          <span class="icon-thumbnail"><heart-icon /></span>
          <ul class="sub-menu">
            <li v-for="category in getCategories">
              <router-link class="sub-menu"
                           :to="{ name: 'recipes', params: { cat_id: category.Id} }">
                <span class="title">{{ category.Text }}</span>
              </router-link>
              <span class="icon-thumbnail">{{ category.AmountOfRecipes }}</span>
            </li>
          </ul>
        </li>

        <li class="">
          <router-link :to="{ name: 'dashboard' }">
            <span class="title">Dashboard</span>
          </router-link>
          <span class="icon-thumbnail"><chart-icon/></span>
        </li>

        <li :class="{ 'open active': menu.infoOpen }">
          <a href="#"
             @click="openMenuItem('infoOpen')">
            <span class="title">{{ $t('menu_info') }}</span>
            <span class=" arrow"
                  :class="{ 'open active': menu.infoOpen }"></span>
          </a>
          <span class="icon-thumbnail"><info-icon /></span>
          <ul class="sub-menu">
            <li class="">
              <router-link :to="{ name: 'tips' }">{{ $t('menu_tips') }}</router-link>
              <span class="icon-thumbnail"><bookmark-icon /></span>
            </li>
            <li class="">
              <router-link :to="{ name: 'info' }">{{ $t('menu_info') }}</router-link>
              <span class="icon-thumbnail"><info-icon /></span>
            </li>
            <li class="">
              <router-link :to="{ name: 'FAQ' }">{{ $t('menu_faq') }}</router-link>
              <span class="icon-thumbnail"><star-icon /></span>
            </li>
            <li class="" v-if="showExtra">
              <router-link :to="{ name: 'content', params: {name: 'SabicWellProgram'} }">{{ $t('menu_extra') }}</router-link>
              <span class="icon-thumbnail"><human-handsup-icon /></span>
            </li>
            <li class="">
              <router-link :to="{ name: 'contact' }">{{ $t('menu_contact') }}</router-link>
              <span class="icon-thumbnail"><phone-icon /></span>
            </li>
          </ul>
        </li>
        <hr>
        <li :class="{ 'open active': menu.profileOpen }">
          <a href="#"
             @click="openMenuItem('profileOpen')">
            <span class="title">{{ $t('menu_profile') }}</span>
            <span class=" arrow"
                  :class="{ 'open active': menu.profileOpen }"></span>
          </a>
          <span class="icon-thumbnail"><human-icon /></span>
          <ul class="sub-menu">
            <li class="">
              <router-link :to="{ name: 'login' }">{{ $t('menu_login') }}</router-link>
              <span class="icon-thumbnail"><human-icon /></span>
            </li>
            <li class="">
              <router-link :to="{ name: 'settings' }">{{ $t('menu_settings') }}</router-link>
              <span class="icon-thumbnail"><settings-icon /></span>
            </li>
            <li class="">
              <router-link :to="{ name: 'logout' }">{{ $t('menu_logout') }}</router-link>
              <span class="icon-thumbnail"><logout-icon /></span>
            </li>
          </ul>
        </li>
      </ul>
      <div class="clearfix"></div>
    </div>
  </nav>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { mapMutations } from 'vuex'
  import HomeIcon from 'vue-material-design-icons/Home'
  import CalendarIcon from 'vue-material-design-icons/Calendar'
  import HeartIcon from 'vue-material-design-icons/Heart'
  import InfoIcon from 'vue-material-design-icons/Information'
  import BookmarkIcon from 'vue-material-design-icons/Bookmark'
  import StarIcon from 'vue-material-design-icons/Star'
  import PhoneIcon from 'vue-material-design-icons/Phone'
  import HumanIcon from 'vue-material-design-icons/Human'
  import HumanHandsupIcon from 'vue-material-design-icons/HumanHandsup'
  import SettingsIcon from 'vue-material-design-icons/Settings'
  import LogoutIcon from 'vue-material-design-icons/Logout'
  import ChartIcon from 'vue-material-design-icons/ChartBar'

  export default {
    components: {
      HumanHandsupIcon,
      HomeIcon, CalendarIcon, HeartIcon, InfoIcon, BookmarkIcon, StarIcon, PhoneIcon, HumanIcon, SettingsIcon, LogoutIcon,
      ChartIcon
    },
    computed: {
      ...mapGetters([
        'getCategories',
        'getSurveys',
        'getSidebarVisible',
        'getSidebarOpen'
      ]),
      showExtra() {
        return window.location.hostname.search('exxonmobil') !== 0
      }
    },
    methods: {
      ...mapMutations([
        'SET_SIDEBAR_VISIBLE',
      ]),
      openMenuItem(item) {
        for (let key in this.menu) {
          if (key === item) {
            this.menu[key] = !this.menu[key]
          } else {
            this.menu[key] = false
          }
        }
      }
    },
    data() {
      return {
        menu: {
          recipeOpen: false,
          infoOpen: false,
          profileOpen: false,
        }
      }
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/utilities/Navbar.vue